import AlachuaNewnansville from "../images/quilts/Alachua_Newnansville.jpg";
import Archer from '../images/quilts/archer-quilt.jpg';
import Gainesville from "../images/quilts/gainesvilleQuilt6_6_24.png";
import Newberry from "../images/quilts/Newberry_quilt.jpg";
import MonteochaGordon from "../images/quilts/Monteocha_Gordan_LeCrosse.jpg";
import YACQuilters from "../images/quilts/Quilt_Youth_Advisory_council_and_Quilters.jpg";
import Waldo from '../images/quilts/waldoQuilt.png';
import Micanopy from '../images/quilts/micanopy-quilt.jpg';
import HighSprings from '../images/quilts/highSprings-quilt.jpg'

 const quiltImages = [
    {
        img_title: "Alachua and Newnansville Quilt",
        img_caption: `The purpose of this Quilt Project is
        to honor the memory of victims of
        racial violence that took place in
        the nearby town of Newnansville.`,
        img_src: AlachuaNewnansville
    },
    {
        img_title: "Archer Quilt",
        img_caption: `The purpose of this quilt is to honor and memorialize the victims of racial terror in Archer, Florida`,
        img_src: Archer
    },
    {
        img_title: "Gainesville Quilt",
        img_caption: `The purpose of this quilt is to honor and
        memorialize the victims of racial terror
        in Gainesville, Alachua County, Florida.`,
        img_src: Gainesville
    },
    {
        img_title: "High Springs Quilt",
        img_caption: `The purpose of this quilt is to honor and
        memorialize the victims of racial terror
        in High Springs, Alachua County, Florida.`,
        img_src: HighSprings
    },
    {
        img_title: " Micanopy Quilt",
        img_caption: `The purpose of this quilt is to honor and
        memorialize the victims of racial terror
        in Micanopy, Alachua County, Florida.`,
        img_src: Micanopy
    },
    {
        img_title: "Monteocha, Gordon, and LaCrosse Quilt",
        img_caption: `The purpose of this quilt is to honor and
        memorialize the victims of racial terror
        in Monteocha, Gordon, LaCrosse, Alachua County, Florida.`,
        img_src: MonteochaGordon
    },
    {
        img_title: "Newberry Quilt", 
        img_caption: `The purpose of this quilt is to honor
        and memorialize the victims of
        racial terror in Newberry, Alachua
        County, Florida.`,
        img_src: Newberry
    },
   
    

    {
        img_title: " Waldo, Hawthorne, Campville, and Rochelle Quilt",
        img_caption: `The purpose of this quilt is to honor and
        memorialize the victims of racial terror
        in Waldo, Hawthorne, Campville, Rochelle, Alachua County, Florida.`,
        img_src: Waldo
    },
    {
        img_title: "Youth Advisory Council and Quilters",
        img_caption: `Picture of Youth Advisory Council and Quilters`,
        img_src: YACQuilters
    }
   
];

export default quiltImages;
